import React from "react";
import Title from "../layouts/Title";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { BiPhoneCall } from "react-icons/bi";
import ScrollReveal from "../layouts/ScrollReveal";

const Contact = () => {
  return (
    <section
      id="contact"
      className="w-full py-20 border-b-[1px] border-b-cardBg"
    >
      <div className="max-w-screen-xl mx-auto px-4">
        <Title title="Let's Collaborate" />
        <div className="max-w-screen-md mx-auto text-center">
          <ScrollReveal>
            <p className="font-sans font-normal text-lightText text-base mb-6 max-w-[60ch] mx-auto">
              Want to discuss a project or just say hi? My inbox is open.
            </p>

            <a
              href="mailto:text2imtiaz@gmail.com"
              className="inline-flex items-center justify-center px-8 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-sans font-medium text-base rounded-md hover:scale-105 hover:shadow-[0_0_15px_rgba(67,97,238,0.5)] transition-all duration-300"
            >
              <MdEmail className="mr-2" />
              Get In Touch
            </a>

            <div className="mt-8 flex flex-col items-center gap-4">
              <div className="flex justify-center gap-4">
                <a
                  href="https://github.com/imtiaz-pranto/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 text-grayText hover:text-accentBlue hover:scale-110 transition-all duration-300 flex items-center justify-center m-2"
                >
                  <FaGithub className="text-2xl" />
                </a>
                <a
                  href="https://www.linkedin.com/in/imtiaz-pranto/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 text-grayText hover:text-accentBlue hover:scale-110 transition-all duration-300 flex items-center justify-center m-2"
                >
                  <FaLinkedinIn className="text-2xl" />
                </a>
              </div>

              <div className="flex flex-col items-center mt-4 gap-2">
                <p className="font-sans font-normal text-grayText flex items-center">
                  <MdEmail className="mr-2" /> text2imtiaz@gmail.com
                </p>
                <p className="font-sans font-normal text-grayText flex items-center">
                  <BiPhoneCall className="mr-2" /> +8801727834235
                </p>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default Contact;
